import { DecimalPipe } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { ProgramAccountProfileService } from '@carm/_core/program-account-profile/services/program-account-profile.service';
import { BasePageComponent } from '@carm/_utils/base-page.component';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { last, takeUntil } from 'rxjs/operators';
import { standardCarmMoneyFormat } from '@carm/_utils/utility-functions';
import { combineLatest } from 'rxjs';
import { CarmRouter } from '@carm/_core/carm-router/services/carm-router.service';

@Component({
  selector: 'carm-financial-widget',
  templateUrl: './financial.component.html',
  styleUrls: ['./financial.component.scss']
})
export class FinancialWidgetComponent extends BasePageComponent implements OnInit {
  makeAPaymentUrl: string;
  currentAmountDue: string;
  totalOverdueBalance: string;
  public transactionHistoryUrl: string;
  public loading = true;

  constructor(
    private programAccountProfileService: ProgramAccountProfileService,
    private decimalPipe: DecimalPipe,
    private carmRouter: CarmRouter,
    @Inject(LOCALE_ID) public currentLocal: string
  ) {
    super();
  }

  ngOnInit(): void {

    this.makeAPaymentUrl = RoutesConst.Financial_TransactionHistory;
    this.transactionHistoryUrl = RoutesConst.Financial_TransactionHistory;

    combineLatest([
      this.carmRouter.bn9$,
      this.carmRouter.bn15$,
    ])
    .pipe(takeUntil(this.destroy$))
    .subscribe(([bn9, programId]) => {

      this.loading = true;
      this.programAccountProfileService
      .getProgramBalancenById(bn9, programId)
        .pipe(takeUntil(this.destroy$), last())
        .subscribe(programInfo => {
          this.currentAmountDue = !isNaN(programInfo.totalNetOpenBalance)
            ? standardCarmMoneyFormat(
                this.decimalPipe,
                programInfo.totalNetOpenBalance,
                null,
                this.currentLocal
              )
            : standardCarmMoneyFormat(this.decimalPipe, 0);

          this.totalOverdueBalance = standardCarmMoneyFormat(
            this.decimalPipe,
            programInfo.payableBalance,
            null,
            this.currentLocal
          )
          this.loading = false;
        }, (err) => {
          this.loading = false;
          this.currentAmountDue = null;
          this.trySetPageErrorMessages(err);
        }
        );
    }, () => this.loading = false);

  }
}
